package dtos.games.outgoing

import core.enums.EActivityStateDB
import core.enums.EResultDB
import core.enums.EScheduleTypeDB
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GameInfoDTOOut(

    @SerialName("id")
    val mGameId: Int,

    @SerialName("homeScore")
    val mHomeScore: Int,

    @SerialName("guestScore")
    val mGuestScore: Int,

    @SerialName("currentGamePeriod")
    val mCurrentGamePeriod: Int?,

    @SerialName("timeLeftInCurrentGamePeriod")
    val mTimeLeftInCurrentGamePeriod: String?,

    @SerialName("activityState")
    val mActivityState: EActivityStateDB,

    @SerialName("scheduleType")
    val mScheduleType: EScheduleTypeDB,

    @SerialName("homeTeamName")
    val mHomeTeamName: String,

    @SerialName("guestTeamName")
    val mGuestTeamName: String,

    @SerialName("homeLogoUrl")
    val mHomeLogoUrl: String?,

    @SerialName("guestLogoUrl")
    val mGuestLogoUrl: String?,

    @SerialName("isHomeMatch")
    val mIsHomeMatch: Boolean,

    @SerialName("gameResult")
    val mGameResult: EResultDB?,

    @SerialName("secondsLeftInCurrentGamePeriod")
    val mSecondsLeftInCurrentGamePeriod: Int?,

    @SerialName("dateAndTime")
    val mDateAndTime: Long,

    @SerialName("liveStreamUrl")
    val mLiveStreamUrl: String?


) {


    // ----------------------------------------------------------------------------
    // Public properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Internal properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Init
    // ----------------------------------------------------------------------------
    init {

    }

    // ----------------------------------------------------------------------------
    // Constructor
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // System/Overridden methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Interfaces/Listener
    // ----------------------------------------------------------------------------
}
